/* eslint-disable */
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Scooper from "@/components/Icons/Scooper"

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
    values: {
      scooper: {
        component: Scooper,
      }
    }
  },
  theme: {
    themes: {
      light: {
        primary: '#3366CC', // #1976D2 Default Vuetify
        branding: '#00838F', // undefined Default Vuetify
        secondary: '#424242',
        accent: '#00838F', // #82B1FF Default Vuetify
        error: '#FF5252',
        info: '#3366CC', // '#2196F3'
        success: '#4CAF50',
        warning: '#FFC107',
        header: '#212121'
      },
    },
    options: { customProperties: true }
  },
});
